import { BrowserPhoneAction, BrowserPhoneState } from "./telephonyTypes";

export const browserPhoneInitialState = {
  state: BrowserPhoneState.DISCONNECTED,
  config: null,
  error: null,
  activeCall: null,
  muted: false,
  hold: false,
  history: [],
};

export const browserPhoneReducer = (state, action) => {
  switch (action.type) {
    case BrowserPhoneAction.SET_CONFIG:
      return { ...state, config: action.payload };
    case BrowserPhoneAction.SET_STATE:
      return { ...state, state: action.payload };
    case BrowserPhoneAction.SET_ERROR:
      return { ...state, error: action.payload };
    case BrowserPhoneAction.SET_CALL:
      return { ...state, activeCall: action.payload };
    case BrowserPhoneAction.SET_MUTED:
      return { ...state, muted: action.payload };
    case BrowserPhoneAction.SET_HOLD:
      return { ...state, hold: action.payload };
    case BrowserPhoneAction.SET_HISTORY:
      return { ...state, history: action.payload };
    default:
      return state;
  }
};
